import React from "react";
import {
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
} from "recharts";
import { _formatPrice } from "../../../../../../shared/helpers/utils";
import { formatDate } from '../../../exportreport/utils';

const CustomBarChart = ({ theme, data, height = 300, isWeekly }) => {
  const maxValue = Math.max(...data.map((item) => item.value));

  // Format the Y-axis ticks as prices
  const formatter = (tickValue) => {
    
    if (!tickValue) return tickValue === 0 ? '' : tickValue;
    return tickValue === 0 ? '' :  _formatPrice(tickValue); // Assuming _formatPrice formats numbers as "$1,000"
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart
        data={data}
        margin={{ top: 50, right: 30, left: 0, bottom: 20 }}
      >
        <XAxis
          dataKey="date"
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 500,
          }}
          angle={-45}
          textAnchor="end"
          padding={{ left: 20, right: 20 }}
          height={100}
          tickFormatter={ (tick) => formatDate(tick, isWeekly )} 
        />

        <YAxis
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          domain={[0, maxValue]}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 500,
          }}
          tickFormatter={formatter}
        />
        <Line
          type="monotone"
          className="line-chart-element"
          strokeWidth={4}
          dot={false}
          strokeLinecap="butt"
          dataKey="NewDev"
        />
        <Line
          type="monotone"
          dataKey="Condo"
          stroke="#D3A15D"
          strokeWidth={4}
          strokeLinecap="butt"
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="Coop"
          stroke="#A3A3A3"
          strokeWidth={4}
          strokeLinecap="butt"
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
